import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=10f7c39b&scoped=true"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"
import style0 from "./HeroSection.vue?vue&type=style&index=0&id=10f7c39b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f7c39b",
  null
  
)

export default component.exports